import { ALL_WORD } from 'global/constants';
import {
  EVENT_ACTION_REMOVE_FILTER,
  EVENT_ACTION_ADD_FILTER,
} from './data-events.constants';
import { pushDataTrackerEvent } from './data-tracker-push';
import {
  DataTrackerEventData,
  DATA_TRACKER_EVENT_TARGET_TYPE,
} from './data-tracker.constants';

export function pushDataTrackingFilterEvent({
  eventCategory,
  eventData,
  option,
  selectedOptions,
}: {
  eventCategory: string;
  eventData: DataTrackerEventData;
  option: string;
  selectedOptions?: string[];
}) {
  const isClearAllOption = option.toLowerCase() === ALL_WORD;
  const hasClearAllSelectedOption =
    selectedOptions?.[0] && selectedOptions[0].toLowerCase() === ALL_WORD;

  const isDuplicateClearAll =
    selectedOptions?.length === 1 &&
    isClearAllOption &&
    hasClearAllSelectedOption;

  const isClearAllOnEmptySelection =
    !selectedOptions?.length && isClearAllOption;

  const eventAction =
    (selectedOptions && selectedOptions.includes(option)) || isClearAllOption
      ? EVENT_ACTION_REMOVE_FILTER
      : EVENT_ACTION_ADD_FILTER;

  pushDataTrackerEvent(eventCategory, eventAction, {
    ...eventData,
    target_type: eventData[DATA_TRACKER_EVENT_TARGET_TYPE],
    target_identifier: option,
    state_change: !(isDuplicateClearAll || isClearAllOnEmptySelection),
  });
}
